import React, { useEffect, createElement } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { HomePage } from './pages/HomePage';
import { BriefingPage } from './pages/BriefingPage';
const GA_ID = 'G-HZZZP0GQTN';
export function App() {
  useEffect(() => {
    // Inject gtag.js script
    const script1 = document.createElement('script');
    script1.async = true;
    script1.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
    document.head.appendChild(script1);
    // Inject gtag config script
    const script2 = document.createElement('script');
    script2.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '${GA_ID}');
    `;
    document.head.appendChild(script2);
  }, []);
  return <BrowserRouter data-id="element-0">
      <div className="min-h-screen bg-[#0a1628] text-white selection:bg-[#38bdf8] selection:text-[#0a1628]" data-id="element-1">
        <Navbar data-id="element-2" />
        <main data-id="element-3">
          <Routes data-id="element-4">
            <Route path="/" element={<HomePage data-id="element-6" />} data-id="element-5" />
            <Route path="/briefing" element={<BriefingPage data-id="element-8" />} data-id="element-7" />
          </Routes>
        </main>
        <Footer data-id="element-9" />
      </div>
    </BrowserRouter>;
}